import React from 'react'
import cx from 'classnames'
import { BtnV2, Icon, Link, l, sanitizeURL } from '@manychat/manyui'

import { URL_HAS_PROTOCOL_REGEX } from 'constants/RegExs'

import cm from './styles.module.css'

const convertUrl = (url?: string) => {
  if (!url) {
    return '#'
  }

  if (!URL_HAS_PROTOCOL_REGEX.test(url)) {
    return sanitizeURL(`https://${url}`)
  }
  return sanitizeURL(url)
}

interface MetaInfoProps {
  isNewEntry: boolean
  updatedAt?: string
  url?: string
  onRescan?: () => void
}

export const MetaInfo = ({ isNewEntry, updatedAt, url, onRescan }: MetaInfoProps) => {
  return (
    <div className={cm.meta}>
      {url && (
        <div className={cm.metaCard}>
          <div className={cm.metaCard__title}>
            <Icon.Link className={cm.metaCard__icon} size={24} />

            <p className="text-secondary m-t-0">
              {l.translate('<l10n context="Noun phrase"/>Source link')}
            </p>
          </div>

          <div className={cm.metaCard__content}>
            <Link
              as="a"
              contentColor="subtle"
              target="_blank"
              href={convertUrl(url)}
              variant="body"
            >
              {url}
            </Link>

            {!isNewEntry && onRescan && (
              <BtnV2
                className={cm.metaCard__button}
                ariaLabel={l.translate('Rescan link')}
                label={l.translate('Rescan link')}
                leftIcon="Retry"
                size="default"
                type="button"
                variant="ghost-primary"
                onClick={() => onRescan()}
                data-title={l.translate(
                  'Rescan to update content. Previous manual edits will be lost.',
                )}
                data-title-at="bottom"
              />
            )}
          </div>
        </div>
      )}

      {!isNewEntry && updatedAt && (
        <div className={cm.metaCard}>
          <div className={cm.metaCard__title}>
            <Icon.Time className={cm.metaCard__icon} size={24} />

            <p className="text-secondary m-t-0">{l.translate('Last updated')}</p>
          </div>

          <p className={cx('m-t-0', cm.metaCard__content)}>{l.dateFromNow(updatedAt)}</p>
        </div>
      )}
    </div>
  )
}
